<template>
  <div class="collection">
    <div class="body-right-upload-list mach-width">

      <div v-if="list.length">
        <div v-for="(s,idx) in list" :key="idx" class="body-right-upload-list-item position-relative flex" :class="s.status==8 && s.releaseStatus == 1 ? 'cursor':''" :data-index="idx" @mouseleave="mouseleave" @mouseover="sourceOver" @click="toDetail">
          <div class="body-right-upload-list-item-img">
            <div class="img" :style="{backgroundImage: 'url('+ s.preview + ')'}" />
          </div>
          <div class="body-right-upload-list-item-info flex-1">
            <div class="body-right-upload-list-item-info-tit flex-row-align-center">
              <p class=" font-bold text-line-1 mach-width font-color-264480 font-size-18">{{ s.collectionName }}</p>
            </div>
            <div class="body-right-upload-list-item-info-desc flex-row-align-center">
              <p class="font-size-14 font-color-666 text-line-1">{{ s.description }}</p>
            </div>
            <div class="body-right-upload-list-item-info-mark flex-row-justify-space-between flex-row-align-center">
              <div class="flex">
                <div v-if="s.status==8 && s.releaseStatus == 1" class="body-right-upload-list-item-info-mark-item status-success radius-clip-5 flex-center status-sccess">
                  <p class="font-size-12">已发布</p>
                </div>
                <div v-if="s.status==5 && s.auditTagStatus == 0" class="body-right-upload-list-item-info-mark-item status-success radius-clip-5 flex-center status-ing ">
                  <p class="font-size-12">审核中</p>
                </div>
                <div v-if="s.status==8 && s.releaseStatus == 0" class="body-right-upload-list-item-info-mark-item status-success radius-clip-5 flex-center status-ing ">
                  <p class="font-size-12">审核中</p>
                </div>
                <div v-if="s.status==6 && s.publisherStatus == 0" class="body-right-upload-list-item-info-mark-item status-success radius-clip-5 flex-center status-ing ">
                  <p class="font-size-12">审核中</p>
                </div>
                <div v-if="s.status==5 && s.auditTagStatus == 2 && s.isDeleted == 1" class="body-right-upload-list-item-info-mark-item status-success radius-clip-5 flex-center status-fail">
                  <p class="font-size-12">未通过</p>
                </div>
                <div v-if="s.pictureNumber || s.videoNumber || s.audioNumber || s.pdfNumber > 0 || s.zipNumber > 0" class="body-right-upload-list-item-info-mark-item status-success radius-clip-5 flex-center">
                  <p v-if="s.pictureNumber" class="font-size-12">{{ s.pictureNumber }}图片</p>
                  <p v-if="s.videoNumber" class="font-size-12">{{ s.videoNumber }}视频</p>
                  <p v-if="s.audioNumber" class="font-size-12">{{ s.audioNumber }}音频</p>
                  <p v-if="s.pdfNumber > 0" class="font-size-12">{{ s.pdfNumber }}文稿</p>
                  <p v-if="s.zipNumber > 0" class="font-size-12">{{ s.zipNumber }}文件</p>
                </div>
              </div>
              <div v-if="mouseOverIndex==idx && s.status==8 && s.releaseStatus == 1 && (s.applyRemoveStatus == 0 || s.applyRemoveStatus == -1)" class="body-right-upload-list-item-info-mark-del flex-center cursor" :data-index="idx" @click.stop="showdelapply"> <p class="font-size-12 font-color-264480">删除</p></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="empty flex-center">
        <p class=" font-size-14">暂无馆藏</p>
      </div>
    </div>
    <!-- 分页器 -->
    <div v-if="totalPage>1" class="data-pagination mach-width flex-center">
      <el-pagination next-text="下一页" prev-text="上一页" background hide-on-single-page :current-page.sync="current" :page-size="10" layout="total, prev, pager, next" :total="total" @current-change="jumpPage" />
    </div>
    <!-- <div v-if="totalPage>1" class="data-pagination mach-width flex-center">
      <pagination
        v-if="totalPage>=1"
        :pages="totalPage"
        :groups="totalPage>5?5:totalPage"
        @jump="jumpPage"
      />
    </div> -->
    <applyRemove ref="delapply" :datas="applyDelReason" @apply="requestDelsource" />
  </div>
</template>

<script>

import api from '../../../../../api/userpage.js'
import apply from '../../../../../api/common.js'
// import pagination from '@/components/Paginate.vue'
import applyRemove from '@/components/applyremove/index.vue'

export default {
  components: {
    // pagination,
    applyRemove
  },
  props: {
    status: {
      required: true,
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      list: [],
      totalPage: 1,
      total: 0,
      mouseOverIndex: -1,
      showDelDialog: false,
      reqdel: {
        length: 0,
        desc: '',
        index: -1
      },
      applyDelReason: [],
      reqParamSize: { current: 1, size: 10 },
      current: 1
    }
  },
  watch: {
    status() {
      this.current = 1
      this.request()
    }
  },
  created() {
    this.request()
  },
  methods: {
    request() {
      var params = {}
      const paramsSize = { current: this.current, size: 10 }
      if (parseInt(this.status) === 0) {
        params = {
          chooseType: 1
        }
      } else if (parseInt(this.status) === 1) {
        params = {
          chooseType: 3
        }
      } else if (parseInt(this.status) === 2) {
        params = {
          chooseType: 2
        }
      } else if (parseInt(this.status) === 3) {
        params = {
          chooseType: 4
        }
      }
      params = Object.assign(paramsSize, params)
      const that = this
      api.personsources(params).then(r => {
        that.list = that.prepearData(r.data.records)
        that.totalPage = r.data.pages
        that.total = r.data.total
      }).catch(() => {
        that.list = []
      })

      apply.listmenu({ code: 'delete_type' }).then(r => {
        that.applyDelReason = r.data[0].children
      })
    },
    prepearData(data) {
      data.forEach(v => {
        var title = v.collectionName
        if (v.subtitle) {
          title = title + '-' + v.subtitle
        }
        if (v.chapter) {
          title = title + '-' + v.chapter
        }
        v.collectionName = title
      })
      return data
    },
    requestDelsource(e) {
      const params = {
        collectionId: this.list[this.reqdel.index].collectionId,
        removeTypeCode: e.id,
        removeContent: e.desc
      }
      const that = this
      api.removesource(params).then(r => {
        that.list[that.reqdel.index].applyRemoveStatus = 1
        that.$message({
          showClose: false,
          message: '删除申请已提交',
          type: 'success'
        })
      }).catch(() => {
        that.$message({
          showClose: false,
          message: '删除申请提交失败',
          type: 'error'
        })
      })
    },
    sourceOver(e) {
      this.mouseOverIndex = e.currentTarget.dataset.index
      console.log(e.currentTarget.dataset.index)
    },
    inputChange(e) {
      this.reqdel.length = e.target.value.length
      this.reqdel.desc = e.target.value
    },
    mouseleave() {
      this.mouseOverIndex = -1
    },
    showdelapply(e) {
      this.$refs.delapply.show()
      this.reqdel.index = e.currentTarget.dataset.index
    },
    dismiss() {
      this.requestDelsource()
    },
    jumpPage(v) {
      this.current = v
      this.request()
    },
    toDetail(v) {
      const index = v.currentTarget.dataset.index
      const value = this.list[index]
      if (value.status === 8 && value.releaseStatus === 1) {
        const routeData = this.$router.resolve({
          name: 'Resource',
          query: {
            rsId: value.id,
            permission: value.permissionRange,
            me: 1
          }
        })
        window.open(routeData.href, '_blank')
      }
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>

<style scoped>
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  color: rgb(38, 68, 128);
  font-size: 14px;
  font-weight: 600;
  background-color: rgb(243, 244, 249);
}

::v-deep .el-pager li {
  padding: 0 4px;
  font-size: 14px;
  background-color: transparent !important;
  font-weight: 500;
  color: rgb(38, 68, 128);
  /* height: 28px; */
  line-height: 28px;
  /* box-sizing: border-box; */
  text-align: center;
}

::v-deep .btn-next {
  padding: 0 4px;
  font-size: 14px;
  background-color: transparent !important;
  font-weight: 500;
  color: rgb(38, 68, 128);
  /* height: 28px; */
  line-height: 28px;
  /* box-sizing: border-box; */
  text-align: center;
}

::v-deep .btn-prev {
  padding: 0 4px;
  font-size: 14px;
  background-color: transparent !important;
  font-weight: 500;
  color: rgb(38, 68, 128);
  /* height: 28px; */
  line-height: 28px;
  /* box-sizing: border-box; */
  text-align: center;
}
</style>
<style scoped>
  .body-right-upload-list {
    padding-top: 8px;
  }

  .body-right-upload-list-item-img {
    width: 146px;
    padding-top: 32px;
    margin-right: 26px;
  }

  .body-right-upload-list-item-img .img {
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center;
    width: 146px;
    height: 98px;
  }

  .body-right-upload-list-item-info {
    padding-top: 24px;
  }

  .body-right-upload-list-item-info-tit {
   height: 30px;
   overflow: hidden;
 }

 .body-right-upload-list-item-info-tit p {
   flex-shrink: 0;
 }

  .body-right-upload-list-item-info-desc {
    height: 40px;
  }

  .body-right-upload-list-item-info-mark {
    margin-top: 10px;
  }

  .body-right-upload-list-item-info-mark-item {
    height: 24px;
    padding: 6px 8px;
    margin-right: 10px;
  }

  .status-success {
    background-color: #F3F4F9;
  }

  .status-success p {
    color: rgba(0, 0, 0, 0.5);
  }

  .status-fail {
    background-color: rgba(205, 46, 46,0.1)
  }

  .status-fail p {
    color: #CD2E2E;
  }

  .status-ing {
    background-color: rgba(211, 160, 48, 0.2)
  }

  .status-ing p {
    color: #D3A030;
  }

  .body-right-upload-list-item-info-mark-del {
    width: 100px;
    height: 24px;
  }

  .body-right-upload-list-item-info-mark-del p {
    opacity: 0.5;
  }

  .data-pagination {
    height: 100px;
    /* border-top: 1px solid rgba(38, 42, 51, 0.1); */
  }

  .empty {
    height: 300px;
  }
</style>
